// @file Composable for undoable actions
import { ActionHistoryType, undo } from '@@/bits/action_history_manager'
import { useSurfaceDraftsStore } from '@@/pinia/surface_drafts'
import { useKeyboardShortcutsForUndoRedo } from '@@/vuecomposables/keyboard_shortcuts'

export const useUndoable = (): void => {
  const surfaceDraftsStore = useSurfaceDraftsStore()

  function handleUndo(event: KeyboardEvent): void {
    // Don't trigger undo if the user has an active draft
    if (surfaceDraftsStore.isAnyDraftActive) return

    const action = undo()
    if (action == null) return

    // If the user is on a browser default undoable action (e.g. text input, reopen closed tab), they would trigger
    // both that undoable action and the undoable action we track in our stack
    event.preventDefault()
    event.stopPropagation()

    switch (action.type) {
      case ActionHistoryType.DELETE_DRAFT:
        surfaceDraftsStore.undoDeleteDraft(action.data)
        break
    }
  }

  useKeyboardShortcutsForUndoRedo({
    handleUndo,
  })
}
